module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CONQUEROR_STYLE.0df7be62.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CONQUEROR_STYLE.png
// module id = 1140
// module chunks = 16